import { render, staticRenderFns } from "./AddPalletsGuia.vue?vue&type=template&id=4db2de2a&"
import script from "./AddPalletsGuia.vue?vue&type=script&lang=js&"
export * from "./AddPalletsGuia.vue?vue&type=script&lang=js&"
import style0 from "./AddPalletsGuia.vue?vue&type=style&index=0&id=4db2de2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports